import { render, staticRenderFns } from "./CardEdit.vue?vue&type=template&id=2130db43&"
import script from "./CardEdit.vue?vue&type=script&lang=js&"
export * from "./CardEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports